import React from 'react'
import { withStyles } from 'material-ui/styles'
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from 'material-ui/Table'
import { Link } from 'react-router-dom'
import Button from 'material-ui/Button'
import AddIcon from 'material-ui-icons/Add'
import './products.css'
import { getActualProductId } from './id-handler'

const styles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 200
  }
})

const ProductList = props => {
  const { products, classes, handleNewProduct } = props

  return (
    <div className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Product ID</TableCell>
            <TableCell>Product</TableCell>
            <TableCell>Manufacturer</TableCell>
            <TableCell>Current Price</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map(product => {
            product.prices = product.prices || [] // playing safe incase prices is not with product object

            // sort prices by date in decreasing order of date
            product.prices.sort((price1, price2) => {
              if (price2.date > price1.date) {
                return 1
              }
              if (price2.date < price1.date) {
                return -1
              }

              return 0
            })

            let currentPrice = product.prices[0] || {} // just incase prices[0] is undefined

            return (
              <TableRow key={product._id}>
                <TableCell>{getActualProductId(product._id)}</TableCell>
                <TableCell>{product.name}</TableCell>
                <TableCell>{product.manufacturer}</TableCell>
                <TableCell>{currentPrice.price}</TableCell>
                <TableCell>
                  <Link to={`/products/${encodeURIComponent(product._id)}/edit`}>
                    <Button
                      color='primary'
                      className={classes.button}
                      aria-label='Edit Product'
                    >
                      Edit
                    </Button>
                  </Link>
                  <Link
                    to={`/products/${encodeURIComponent(product._id)}/prices`}
                  >
                    <Button
                      color='primary'
                      variant='raised'
                      className={classes.button}
                      aria-label='Product Prices'
                    >
                      View Prices
                    </Button>
                  </Link>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
      <Button
        id='new-product'
        variant='fab'
        color='primary'
        onClick={handleNewProduct}
      >
        <AddIcon />
      </Button>
    </div>
  )
}

export default withStyles(styles)(ProductList)



// WEBPACK FOOTER //
// ./src/products/ProductList.js